<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="">
        <v-flex xs12>
          <h3 class="text-center">View Request</h3>
        </v-flex>
        <v-flex xs12 md6 sm5 class="pa-1">
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>
              Details
            </v-card-title>
            <v-card-text>
              <my-details :detail="['Location', service_request.location]"></my-details>
              <my-details :detail="['Client Name', service_request.client.name]"></my-details>
              <my-details :detail="['Time', moment(service_request.created_at).format('dddd MMMM D, yyyy H:m')]"></my-details>
              <my-details :detail="['Note', service_request.note]"></my-details>
              <my-details :detail="['Cost', service_request.cost]"></my-details>
              <a download :href="'/' + service_request.file" v-if="service_request.file">Attached File</a>
            </v-card-text>
            <v-card-actions class="py-0 my-0">
              <v-spacer></v-spacer>
              <v-btn small @click="getDirection" title="Get Directions">
                Get Directions
                <v-icon right>mdi-map-marker-distance</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 sm7 id="map" class="pa-1">
          <v-card>
            <v-card-text>
              <gmap-map :center="mycoordinates" :zoom="zoom" style="width: 100%; height: 74vh;">
                <gmap-marker
                  :key="index"
                  label="★"
                  title="Request's Location"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="true"
                  :draggable="false"
                  @click="center=m.position"
                  :animation="4"
                />
              </gmap-map>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import Vue from 'vue'
  import layout from '@/Layouts/User'
  import VueGeolocation from 'vue-browser-geolocation';
  Vue.use(VueGeolocation);
  const MyDetails = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/details.vue')

  export default {
    name: 'ViewRequest',
    layout,
    props: [
      'service_request'
    ],
    components: {
      MyDetails,
    },
    data () {
      return {
        zoom: 6,
        origin: {},
        base: 'https://www.google.com/maps/dir/?api=1'
      }
    },
    methods: {
      getCordinates () {
        var options = {
          enableHighAccuracy: true, //defaults to false
          timeout: Infinity, //defaults to Infinity
          maximumAge: 0 //defaults to 0
        }
        this.$getLocation(options)
        .then(coordinates => {
          this.origin = coordinates
          this.zoom = 7
        })
        .catch(error => {
          swal(error, 'Location access is needed for this page to work', 'error')
        })
      },
      getDirection () {
        this.getCordinates()
        let $vm = this
        setTimeout(() => {
          let base = $vm.base
          let origin = $vm.origin.lat + ',' + $vm.origin.lng
          let destination = $vm.service_request.latitude + ',' + $vm.service_request.longitude
          var url = base + '&origin=' + origin + '&destination=' + destination

          window.open(url, '_blank')
        }, 2000);
      }
    },
    mounted () {
      this.getCordinates()
    },
    computed: {
      mycoordinates () {
        return {
          lat: this.service_request.latitude,
          lng: this.service_request.longitude
        }
      },
      markers () {
        if (!this.mycoordinates.lat || !this.mycoordinates.lng) {
          return []
        }
        return [
          {
            position: {
              lat: this.mycoordinates.lat,
              lng: this.mycoordinates.lng
            }
          },
          {
            position: {
              lat: this.origin.lat,
              lng: this.origin.lng
            }
          }
        ]
      },
    },
    watch: {
      '$route': 'somemethod',
    }
  }
</script>
